import { GraduationCap } from 'lucide-react';

import { cn } from '@/shared/utils/cn';

/**
 * Aval institucional del programa, con el mismo tratamiento que el beneficio de
 * la card de seminario: navy, icono de acento y negrita sobre lo que diferencia
 * —la institución—, dejando la constante en peso normal.
 */
export function CourseCardAllianceNote({
  label,
  className,
}: {
  label: string;
  className?: string;
}) {
  return (
    <p className={cn('text-navy flex items-start gap-2 text-[0.75rem]', className)}>
      <GraduationCap
        aria-hidden="true"
        className="text-(--color-primary-700) mt-0.5 size-3.5 shrink-0"
      />
      <span className="min-w-0">
        <span className="font-medium">Doble certificación con </span>
        <span className="font-bold">{label}</span>
      </span>
    </p>
  );
}
